import React from 'react';
import CrossRoad from "../UI/Crossroad";
import { tracksColors } from "../../config/styles";

const CrossRoad_16ARed_16CBlack = () => <CrossRoad coords="2344.000000, 416.000000" color={tracksColors.red}/>;

export default CrossRoad_16ARed_16CBlack;
